import { TooltipContentProps, TooltipRootProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Tooltip } from 'src/components/ui/tooltip';
import fonts from 'src/theme/fonts';

interface SmallTooltipProps extends TooltipRootProps {
  label: string;
  children: ReactNode;
  placement?: string;
  contentProps?: TooltipContentProps;
}

export default function SmallTooltip({
  label,
  children,
  placement,
  contentProps,
  ...props
}: SmallTooltipProps) {
  return (
    <Tooltip
      positioning={{ placement: (placement || 'bottom') as any }}
      contentProps={{
        ...contentProps,
        css: {
          '--tooltip-bg': 'podcastShade600',
          maxW: '173px',

          fontFamily: fonts.bold,
          fontSize: '14px',
          lineHeight: '18px',
          color: 'podcastShade100',
          padding: '4px 9px 4px 6px',
          borderRadius: '4px',
          ...contentProps?.css,
        },
      }}
      content={label}
      showArrow
      {...props}
    >
      {children}
    </Tooltip>
  );
}
